import { ReferralImpact, ReferralImpactIncludedType } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const getReferralImpact = async (
  _,
  userId: string,
  referralImpactIncluded: ReferralImpactIncludedType
): Promise<ReferralImpact> => {
  const includeType = referralImpactIncluded.toLowerCase();
  return await fetchFromAPI(`/users/${userId}/referral-data-${includeType}`);
};
